import { mutatorAction } from 'satcheljs';
import store from '../store/Store';
import type { EnhancedLocation } from 'owa-graph-schema';

/**
 * Action to update the meetingType location in the store.
 */
export default mutatorAction(
    'SET_PBP_MEETING_TYPE_LOCATION',
    function setMeetingTypeLocation(location: EnhancedLocation) {
        store.meetingTypeEditState.location = location;
    }
);
